@if (_document) {
  <div>
    <document-lines-editor
      #lineGrid
      [title]="'Doc::CustomerQuote:ProductsAndServices' | abpLocalization"
      [columnDefs]="columnDefs"
      [rows]="_document?.lines"
      [getContextMenuItems]="getContextMenuItems"
      [onCellFocused]="onCellFocused"
      [onRowSelected]="onRowSelected"
      [onCellValueChanged]="onCellValueChanged"
      [treeData]="true"
      [getDataPath]="getDataPath"
      [textLineRole]="textLineRole"
      [chapterLineRole]="chapterLineRole"
      [readonly]="_readonly"
      [canAddLines]="document.deliveryStatus == SupplierDeliveryStatus.Open"
      [addActionBtns]="addActionBtns"
      [deleteActionEnabled]="
        document.deliveryStatus === SupplierDeliveryStatus.Open && deleteActionEnabled
      "
      [selectedLines]="selectedLines()"
      (deleteLines)="deleteLines()"
      [canExportLines]="false"
      [thirdPartyDoc]="_document"
      [isBusyAdding]="isBusyAdding"
      (onModelUpdated)="onModelUpdated($event)"
    ></document-lines-editor>
  </div>
}
